import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { message } from "antd";
import { INPUT_SIZE } from "../../../common/ThemeConstants";
import FormTextField from "../../../components/general/FormTextField";
import { postRequest } from "../../../services/mainApp.service";
import BasicFormComponentInvTransaction from "../../../components/formComponent/BasicFormComponentInvTransaction";

const initialSearchValues = {
  SearchText: "",
  PageNumber: 1,
  PageSize: 10,
};

const columns = [
  {
    title: "Recipe Name",
    dataIndex: "RecipeName",
    key: "RecipeName",
    width: 200,
  },
  {
    title: "Category",
    dataIndex: "CategoryName",
    key: "CategoryName",
    width: 150,
  },
];

const Recipe = () => {
  const controller = new window.AbortController();
  const userData = useSelector((state) => state.authReducer);

  const [searchFields, setSearchFields] = useState(initialSearchValues);
  const [recipeList, setRecipeList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableColumns] = useState([...columns]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    fetchData();

    return () => {
      controller.abort();
    };
  }, []);

  const fetchData = async (searchParams = {}, pageNumber = 1, pageSize = 10) => {
    setTableLoading(true);
    const payload = {
      OperationId: 1,
      CompanyId: userData.CompanyId,
      UserId: userData.UserId,
      UserIP: "12.1.1.2",
      RecipeId: null,
      ProductDetailId: null,
      SubRecipeItemId: null,
      IsDetailData: false,
      SearchText: searchParams.SearchText || "",
      PageNumber: pageNumber,
      PageSize: pageSize,
      RecipeDetails: [],
    };

    try {
      const response = await postRequest("/Inv_Recipe", payload, controller);
      setTableLoading(false);

      if (response.error) {
        message.error(response.errorMessage);
        return;
      }

      if (response.data.response === false) {
        message.error(
          response.data.DataSet?.Table?.errorMessage || "Error fetching data"
        );
        return;
      }

      const dataSet = response.data;
      setRecipeList(dataSet.Data || dataSet.DataSet?.Table || []);

      const totalCount =
        dataSet?.TotalCount ||
        dataSet?.TotalRecords ||
        dataSet?.Data?.length ||
        0;
      setPagination((prev) => ({
        ...prev,
        current: pageNumber,
        pageSize: pageSize,
        total: totalCount,
      }));
    } catch (error) {
      setTableLoading(false);
      if (error.message !== "canceled") {
        console.error("Error fetching recipes:", error);
        message.error("Failed to fetch recipes");
      }
    }
  };

  const handleSearchChange = (data) => {
    setSearchFields((prev) => ({ ...prev, [data.name]: data.value }));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPagination((prev) => ({ ...prev, current: 1 }));
    fetchData(searchFields, 1, pagination.pageSize);
  };

  const handleReset = () => {
    setSearchFields(initialSearchValues);
    setPagination((prev) => ({ ...prev, current: 1 }));
    fetchData(initialSearchValues, 1, pagination.pageSize);
  };

  const handleTableChange = (paginationInfo, filters, sorter) => {
    setPagination((prev) => ({
      ...prev,
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize,
    }));

    fetchData(searchFields, paginationInfo.current, paginationInfo.pageSize);
  };

  const handleDeleteRow = (id, record) => {
    const payload = {
      OperationId: 4,
      CompanyId: userData.CompanyId,
      UserId: userData.UserId,
      UserIP: "12.1.1.2",
      RecipeId: id,
      ProductDetailId: null,
      SubRecipeItemId: null,
      IsDetailData: false,
      SearchText: "",
      PageNumber: 1,
      PageSize: 10,
      RecipeDetails: [],
    };

    postRequest("/Inv_Recipe", payload, controller)
      .then((response) => {
        if (response.error) {
          message.error(response.errorMessage);
          return;
        }
        if (response.data.response === false) {
          message.error(
            response.data.DataSet?.Table?.errorMessage ||
              "Error deleting recipe"
          );
          return;
        }
        message.success(
          response.successMessage || "Recipe deleted successfully"
        );
        fetchData(searchFields, pagination.current, pagination.pageSize);
      })
      .catch((error) => {
        if (error.message !== "canceled") {
          console.error("Error deleting recipe:", error);
          message.error("Failed to delete recipe");
        }
      });
  };

  const handleEditRow = () => {
    // Navigation to edit is handled by BasicFormComponentInvTransaction
  };

  const searchPanel = (
    <Fragment>
      <FormTextField
        colSpan={6}
        label="Search"
        name="SearchText"
        size={INPUT_SIZE}
        value={searchFields.SearchText}
        onChange={handleSearchChange}
      />
    </Fragment>
  );

  return (
    <BasicFormComponentInvTransaction
      formTitle="Recipe"
      searchPanel={searchPanel}
      searchSubmit={handleSearchSubmit}
      tableColumn={tableColumns}
      tableRows={recipeList}
      tableLoading={tableLoading}
      actionID="RecipeId"
      editRow={handleEditRow}
      deleteRow={handleDeleteRow}
      baseRoute="/recipe"
      reset={false}
      handleReset={handleReset}
      paginationConfig={{
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: pagination.total,
        showSizeChanger: true,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} items`,
      }}
      onPaginationChange={handleTableChange}
    />
  );
};

export default Recipe;
